import { AdminInput, Div } from '@vgrubs/components';
import type {
  AnnouncementDraft,
  UpdateAnnouncementDraft,
} from '../helpers/announcementPayload';

type Props = {
  draft: AnnouncementDraft;
  onChange: UpdateAnnouncementDraft;
};

export const AnnouncementContentStep = ({ draft, onChange }: Props) => (
  <Div $flex $column $gap="24px" $mt="20">
    <AdminInput
      label="Title"
      placeholder="Enter here"
      value={draft.title}
      onChange={(e) => onChange('title', e.target.value)}
    />
    <AdminInput
      label="Body (markdown)"
      placeholder="## What's new..."
      value={draft.body}
      onChange={(e) => onChange('body', e.target.value)}
      type="textarea"
      $textareaHeight="350"
    />
  </Div>
);
